import combineResults from "../../../../utils/combineResultsData";

export const DEFAULT_SCRATCH_DEDUCTION = 0.1;

export const hasScratch = (itemResult) => itemResult.unit === "seconds";

// The checkbox and deduction of a block are keyed by the block's first fieldId
export const getScratchKey = (itemResult) => itemResult.test[0].fieldId;

const scratchBlocks = combineResults.filter(hasScratch);

export const scratchKeyByFieldId = scratchBlocks.reduce((acc, block) => {
  block.test.forEach((t) => (acc[t.fieldId] = getScratchKey(block)));
  return acc;
}, {});

export const setScratchFields = (scratchKey, deduction) => {
  const checkbox = document.getElementById(`scratch-${scratchKey}`);
  const deductionInput = document.getElementById(
    `scratchDeduction-${scratchKey}`,
  );
  if (!checkbox || !deductionInput) return;

  const isScratched = deduction != null;
  checkbox.checked = isScratched;
  deductionInput.disabled = !isScratched;
  deductionInput.value = isScratched ? deduction : "";
};

export const clearScratchFields = () =>
  scratchBlocks.forEach((block) =>
    setScratchFields(getScratchKey(block), null),
  );

// Returns the deduction of a block, or null when Scratch is unchecked
export const readScratchDeduction = (scratchKey) => {
  const checkbox = document.getElementById(`scratch-${scratchKey}`);
  if (!checkbox?.checked) return null;
  const deductionInput = document.getElementById(
    `scratchDeduction-${scratchKey}`,
  );
  return parseFloat(deductionInput?.value);
};

export const getScratchError = () => {
  const invalidBlock = scratchBlocks.find((block) => {
    const deduction = readScratchDeduction(getScratchKey(block));
    return deduction !== null && !(deduction > 0);
  });
  return invalidBlock
    ? `Enter a scratch deduction greater than 0 for ${invalidBlock.name} attempt ${invalidBlock.attempt}.`
    : null;
};
